import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { LazyRoute } from './LazyRoute';

const FlashcardsPage = lazy(() => import('@/features/flashcards/pages/FlashcardsPage'));
const CreateDeckPage = lazy(() => import('@/features/flashcards/pages/CreateDeckPage'));
const DeckDetailPage = lazy(() => import('@/features/flashcards/pages/DeckDetailPage'));
const StudyPage = lazy(() => import('@/features/flashcards/pages/StudyPage'));

export const flashcardRoutes = (
  <>
    <Route path="/flashcards" element={<LazyRoute fallbackMessage="Loading flashcards..."><FlashcardsPage /></LazyRoute>} />
    <Route path="/flashcards/create" element={<LazyRoute><CreateDeckPage /></LazyRoute>} />
    <Route path="/flashcards/decks/:deckId" element={<LazyRoute><DeckDetailPage /></LazyRoute>} />
    <Route path="/flashcards/review/:deckId" element={<LazyRoute fallbackMessage="Loading review session..."><StudyPage /></LazyRoute>} />
  </>
);
